import { Icon } from "@material-ui/core";
import React from "react";
import Gauge from "react-svg-gauge";
// import * as JustGage from 'justgage';
import PrimaryTheme from "../Themes/Primary";
import Select from "./Select";

export default function Meter(props: IGaugeProps) {
  console.log('My props',props);  
  
  // const gauge = new JustGage({
  //   id: "gauges", // the id of the html element
  //   value: 70,
  //   min: 0,
  //   max: 100,
  //   decimals: 2,
  //   gaugeWidthScale: 0.6
  // });

  const getColor = () => {
    if (props.value <= 25) {
      return "red";
    }
    if (props.value <= 50) {
      return PrimaryTheme.warn;
    }
    if (props.value <= 75) {
      return PrimaryTheme.success;
    }
    if (props.value > 75) {
      return "green";
    }
  };

  return (
    <div
      className="border-radius box-shadow overflow-hidden mb-3"
      style={{
        minHeight: 120,
        backgroundColor: props.background
          ? props.background
          : PrimaryTheme.white,
      }}
    >
      <div className="col-md-12 p-3">
        <div className="row m-0 justify-content-between align-items-center">
          <h6
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              fontSize: 14,
              textTransform: "uppercase",
            }}
          >
            <div className="row m-0 justify-content-center align-items-center">
              {props.title}{" "}
              {props.isLoading && <Icon className="rotate">cached</Icon>}
            </div>
          </h6>
          {props.hasMenu && (
            <Select
              active="Day"
              list={["Day", "Week", "Month"]}
              firstUL={props.id}
              id={props.id}
              onChange={props.onMenuChange}
            />
          )}
        </div>

        <div className="text-center pb-1">
          <div
            style={{
              fontSize: PrimaryTheme.fontSizes?.small,
              fontWeight: 700,
              marginTop: "15px",
            }}
          >
            {props.subTitle}
          </div>
          <div
            className="row"
            style={{
              marginTop: "0px",
              fontSize: props.hasSpecialFontSize
                ? props.hasSpecialFontSize
                : "60px",
              fontWeight: 500,
              color: PrimaryTheme.primary,
            }}
          >
            <div className="col text-center">
              <div>{parseInt(props.value)}</div>
              <div
                style={{
                  fontSize: PrimaryTheme.fontSizes?.small,
                  color: "#4D4F5B",
                  fontWeight: 700,
                }}
              >
                POS Withdrawals
              </div>
            </div>
            <div className="col text-center">
              <div>{props.hasTransfer}</div>
              <div
                style={{
                  fontSize: PrimaryTheme.fontSizes?.small,
                  color: "#4D4F5B",
                  fontWeight: 700,
                }}
              >
                Transfers
              </div>
            </div>
          </div>
          {/* <Gauge
            value={parseInt(props.value)}
            width={props.width ? props.width : 200}
            height={props.height ? props.height : 120}
            max={100}
            // backgroundColor={"black"}
            color={getColor()}
            label={""}
            valueLabelStyle={{
              fontSize: 20
            }}
          /> */}
        </div>
      </div>
    </div>
  );
}

interface IGaugeProps {
  label?: string;
  min?: number;
  id?: string;
  max?: number;
  value: any;
  width?: number;
  hasMenu?: boolean;
  isLoading?: boolean;
  title?: string;
  height?: number;
  minMaxLabelsOffset?: number;
  background?: string;
  minTxt?: string;
  maxTxt?: string;
  color?: any;
  backgroundColor?: string;
  topLabelStyle?: any;
  valueLabelStyle?: any;
  minMaxLabelStyle?: any;
  onMenuChange?: any;
  subTitle?: String;
  hasSpecialFontSize?: any;
  hasTransfer?: any;
  valueFormatter?: (value: number) => string;
}
